const MOBILE_BREAKPOINT = 768;
const END_OF_GRID_ORDER = 99990;
const mobileMql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

function isMobileViewport() {
    return mobileMql.matches;
}

function getCardPosition(card, isMobile) {
    const desktopPosition = parseInt(card.dataset.gridPosition, 10) || 0;
    const mobilePosition = parseInt(card.dataset.gridPositionMobile, 10) || 0;
    const targetPosition = isMobile && mobilePosition > 0 ? mobilePosition : desktopPosition;

    if (!isMobile || targetPosition === 0) return targetPosition;

    // 2-column mobile grid: sit after an even number of products so a full-width
    // card starts on a new row (insert before the following product).
    return targetPosition % 2 === 0 ? targetPosition + 1 : targetPosition;
}

function getCssOrder(targetPosition) {
    if (!targetPosition) return END_OF_GRID_ORDER;
    return targetPosition * 10 - 5;
}

function getGridContainers() {
    const marked = document.querySelectorAll('[data-collection-product-grid]');
    if (marked.length) return Array.from(marked);

    const fallback = document.querySelector('.product-list [class*="grid"]');
    return fallback ? [fallback] : [];
}

function getGridChild(element, grid) {
    let node = element;
    while (node && node.parentElement && node.parentElement !== grid) {
        node = node.parentElement;
    }
    return node || element;
}

function positionGridCards() {
    const isMobile = isMobileViewport();

    getGridContainers().forEach((gridContainer) => {
        gridContainer.querySelectorAll('[data-position]').forEach((product) => {
            const item = getGridChild(product, gridContainer);
            const pos = parseInt(product.dataset.position, 10) || 0;
            item.style.order = String(pos * 10);
        });

        gridContainer.querySelectorAll('[data-grid-card]').forEach((card) => {
            const item = getGridChild(card, gridContainer);
            if (item === card) return;

            item.style.order = String(getCssOrder(getCardPosition(card, isMobile)));
        });
    });
}

function bindThemeBus() {
    if (!window.ThemeBus || window.ThemeBus.__gridCardsBound) return;
    window.ThemeBus.__gridCardsBound = true;
    window.ThemeBus.addEventListener('grid:updated', positionGridCards);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionGridCards);
} else {
    positionGridCards();
}

document.addEventListener('shopify:section:load', positionGridCards);
document.addEventListener('shopify:section:reorder', positionGridCards);
document.addEventListener('shopify:block:select', positionGridCards);

if (typeof mobileMql.addEventListener === 'function') {
    mobileMql.addEventListener('change', positionGridCards);
} else {
    mobileMql.addListener(positionGridCards);
}

bindThemeBus();
document.addEventListener('DOMContentLoaded', bindThemeBus);
window.addEventListener('load', bindThemeBus);
